import { DealerManagementService } from 'src/services/dealer-management.service';
import Spinner from 'src/components/ui/spinner';
import { SYSTEM_ADMIN_PAGE_ACTIVATE_DEALER_MSG_SUCC } from 'src/localization/resouceKeys';
import { Trans } from 'react-i18next';
import { useLocalization } from 'src/utils/useLocalization';
import { useState } from 'react';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import './styles.scss';
const dealerActivation = () => {
    const [dealerNumber, setDealerNumber] = useState('');
    const [isLoading, setloading] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [isSuccess, setIsSuccess] = useState<null | boolean>(null);
    const onChangeDealerNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const regex = /^[A-Za-z0-9]*$/;

        if (regex.test(value)) {
            setDealerNumber(value);
        }
    };
    const { systemAdmin } = useLocalization();

    const handleSubmit = async () => {
        try {
            setShowMessage(false);
            setloading(true);
            const service = new DealerManagementService();
            const res = await service.activateDealer(dealerNumber);
            if (res.data && res.data.activated) {
                setShowMessage(true);
                setIsSuccess(true);
            }
        } catch (e: any) {
            setShowMessage(true);
            setIsSuccess(false);
            if (e.response) {
                if (e.response.data.error.message.includes('already part of'))
                    setIsSuccess(false);
            } else setIsSuccess(null);
        } finally {
            setloading(false);
        }
    };
    return (
        <div className='dashboard-content-wrapper'>
            <div className='dashboard-content-container'>
                <div className='activation-wrapper'>
                    <section className='o-content-section  '>
                        {showMessage && (
                            <Notification
                                content={
                                    isSuccess ? (
                                        <Trans
                                            i18nKey={
                                                SYSTEM_ADMIN_PAGE_ACTIVATE_DEALER_MSG_SUCC
                                            }
                                            values={{
                                                dealerId:
                                                    dealerNumber.toLocaleUpperCase(),
                                            }}
                                        />
                                    ) : isSuccess === false ? (
                                        systemAdmin.PAGE_ACTIVATE_DEALER_MSG_ERR1
                                    ) : (
                                        systemAdmin.PAGE_ACTIVATE_DEALER_MSG_ERR2
                                    )
                                }
                                type={
                                    isSuccess === true
                                        ? NotificationType.SUCCESS
                                        : NotificationType.ERROR
                                }
                                visibility={showMessage}
                                setVisibility={setShowMessage}
                                withoutClose={false}
                            />
                        )}
                        <div className=''>
                            <h5>
                                <span className='c-section-heading__title-text'>
                                    {systemAdmin.PAGE_ACTIVATE_DEALER_TITLE}
                                </span>
                            </h5>
                            <section className='c-form-section'>
                                <div className='c-form-section__content'>
                                    <div className='o-fieldset__row u-mt-large u-mb-large'>
                                        <div className='o-layout'>
                                            <div
                                                className={
                                                    'o-layout__item u-1/1 u-1/1@xs'
                                                }
                                            >
                                                <div className='title'>
                                                    <span className='c-section-heading__title-text'>
                                                        {
                                                            systemAdmin.PAGE_ACTIVATE_DEALER_DESC
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                                <div className='c-form-field'>
                                                    <div className='c-form-field__box'>
                                                        <div>
                                                            <label
                                                                htmlFor='m1l7e063'
                                                                className='c-form-field__label u-mr-xsmall'
                                                            >
                                                                {
                                                                    systemAdmin.PAGE_ACTIVATE_DEALER_TITLE_LABEL
                                                                }
                                                            </label>
                                                        </div>
                                                        <div className='c-input'>
                                                            <input
                                                                className={
                                                                    'c-input__input'
                                                                }
                                                                onChange={
                                                                    onChangeDealerNumber
                                                                }
                                                                type='text'
                                                                value={
                                                                    dealerNumber
                                                                }
                                                                maxLength={6}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='o-layout__item  u-1/1  u-1/1@xs'>
                                                <div className='o-fieldset__row button-group'>
                                                    <button
                                                        className={`c-btn ${
                                                            dealerNumber.length <
                                                            Number('6')
                                                                ? 'btn-secondary'
                                                                : ''
                                                        }`}
                                                        type='button'
                                                        onClick={handleSubmit}
                                                        disabled={
                                                            dealerNumber.length <
                                                                Number('6') ||
                                                            isLoading
                                                        }
                                                    >
                                                        <span className='c-btn__text'>
                                                            {isLoading ? (
                                                                <Spinner />
                                                            ) : (
                                                                systemAdmin.PAGE_ACTIVATE_DEALER_TITLE_BUTTON
                                                            )}
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default dealerActivation;
